// Vue
import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
// Template
import template from './template.vue'
import {HttpService} from "../../../services/HttpService";
import {ContentArea} from "../content_area/ContentArea";

interface RecentSession {
    href: string
    vehicleType: object,
    settings: object
    copyText: string
}

@Component({
    mixins: [template],
    components: {
        ContentArea
    }
})
export class HeaderVehicleConfigs extends Vue {

    private readonly http: HttpService = HttpService.instance

    private configs: Array<RecentSession> = []

    public isLoading = false

    @Prop()
    public lang!: string

    @Prop()
    public country!: string;

    created() {
        this.refresh();
    }

    public mounted()
    {
        if (this['$eventBus']) {
            (this['$eventBus'] as Vue).$on('cms.vehicleconfigs.refresh', this.refresh);
        }
    }

    public beforeDestroy()
    {
        if (this['$eventBus']) {
            (this['$eventBus'] as Vue).$off('cms.vehicleconfigs.refresh', this.refresh);
        }
    }

    public async refresh() {
        this.isLoading = true
        this.configs = await this.getRecentVehicleConfigs()
        this.isLoading = false
    }

    async getRecentVehicleConfigs() {
        let queryUrl = `${APP_API_URL}katalog/v1.0/${this.lang}/recent-sessions`;

        const response = await this.http.get<Array<RecentSession>>(queryUrl);

        return response.body!
    }

    copyConfig(config: RecentSession) {
        const el = document.createElement('textarea');
        el.value = config.copyText;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }

    getFzgTyp(config) {
        if (config.settings && config.settings['filter'] && config.settings['filter']['FZGTYP']) {
            return config.settings['filter']['FZGTYP']
        }

        if (config.settings && config.settings['completeFilter'] && config.settings['completeFilter']['FZGTYP']) {
            return config.settings['completeFilter']['FZGTYP']
        }

        return ''
    }

    getAusfuehrung(config) {
        if (config.settings && config.settings['filter'] && config.settings['filter']['AUSFUEHRUNG']) {
            return config.settings['filter']['AUSFUEHRUNG']
        }

        if (config.settings && config.settings['completeFilter'] && config.settings['completeFilter']['AUSFUEHRUNG']) {
            return config.settings['completeFilter']['AUSFUEHRUNG']
        }

        return ''
    }

    getAntrieb(config) {
        if (config.settings && config.settings['filter'] && config.settings['filter']['ANTRIEB']) {
            return config.settings['filter']['ANTRIEB']
        }

        if (config.settings && config.settings['completeFilter'] && config.settings['completeFilter']['ANTRIEB']) {
            return config.settings['completeFilter']['ANTRIEB']
        }

        return ''
    }
}
